import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=328f5368&scoped=true&"
import script from "./accountSetting.vue?vue&type=script&lang=js&"
export * from "./accountSetting.vue?vue&type=script&lang=js&"
import style0 from "./accountSetting.vue?vue&type=style&index=0&id=328f5368&prod&scoped=true&lang=css&"
import style1 from "./accountSetting.vue?vue&type=style&index=1&id=328f5368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f5368",
  null
  
)

export default component.exports